import { useContext } from "react";
import ActiveMembershipContext from "core/context/ActiveMembershipContext";

const useActiveMembership = () => {
  const context = useContext(ActiveMembershipContext);

  if (context === undefined) {
    throw Error(
      "useActiveMembership must be used within an ActiveMembershipProvider!"
    );
  }

  return context;
};

export default useActiveMembership;
